import { render } from "./DbsBookingConfirmation.vue?vue&type=template&id=5827d102"
import script from "./DbsBookingConfirmation.vue?vue&type=script&lang=js"
export * from "./DbsBookingConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script